import { Promise } from 'core-js'
import Vue from 'vue'

import Content from './services/content'

const store = new Vue.observable({
  ready: false,
  content: {}
})

let eventbus = new Vue();

const ContentCollection = {
  isReady: () => store.ready,
  initialised: async () => {
    while (!store.ready) {
      await new Promise(resolve => setTimeout(resolve, 300))
    }
    return
  },
  reset: () => {
    store.ready = false
    store.content = {}
  },
  eventbus,
  init: async () => {
    ContentCollection.reset()

    await Content.clear()
    await new Promise((resolve) => setTimeout(resolve,1000))
    let content = await Content.list({ ignoreCache: true, params: { simple: true } }).then(({ data }) => data)

    //set content item details
    let contentStore = {}
    content.forEach(contentItem => {
      contentStore[contentItem._id] = contentItem
    })

    Vue.set(store, 'content', contentStore);

    console.log("ContentCollection", store);

    store.ready = true
  },
  refresh: async () => {
    if (!store.ready) return
    console.log("can refresh")
    // ContentCollection.init()
    let content = await Content.list({ ignoreCache: true, params: { simple: true } }).then(({ data }) => data)

    //set content item details
    let contentStore = {}
    content.forEach(contentItem => {
      contentStore[contentItem._id] = contentItem
    })

    Vue.set(store, 'content', contentStore);
  },

  get: (id) => store.content[id],
  getDetails: async (id) => {
    let content = await Content.get(id, {ignoreCache: true}).then(({data}) => data);
    if(content?._id && ContentCollection.get(content._id)) Vue.set(store.content, content._id, content);
    return content;
  },
  getAll: () => store.content,
  list: () => {
    let content = []
    for (const key of Object.keys(store.content)) {
      content.push(store.content[key])
    }

    // if(options && options.orderBy) return _.orderBy(groups, options.orderBy);
    return content
  },

  getShareSnapshot: async (id) => {
    let content = await Content.getShareSnapshot(id, {ignoreCache: true}).then(({data}) => data);
    return content;
  },

  create: async (payload) => {
    let content = await Content.create(payload).then(({data}) => data);
    Vue.set(store.content, content._id, content);
    return content;
  },

  update: async (contentId, payload) => {
    let content = ContentCollection.get(contentId);
    if(!content) throw new Error("content not found");
    let contentRes = await Content.update(contentId, payload).then(({data}) => data);
    Vue.set(store.content, contentRes._id, contentRes);
    return contentRes;
  },

  duplicate: async (contentId, payload) => {
    let content = ContentCollection.get(contentId);
    if(!content) throw new Error("content not found");
    let contentRes = await Content.duplicate(contentId, payload).then(({data}) => data);
    Vue.set(store.content, contentRes._id, contentRes);
    return contentRes;
  },

  transfer: async (contentId, payload) => {
    let content = ContentCollection.get(contentId);
    if(!content) throw new Error("content not found");
    let contentRes = await Content.transfer(contentId, payload).then(({data}) => data);
    Vue.delete(store.content, contentRes._id);
    return contentRes;
  },

  remove: async (contentId) => {
    let content = ContentCollection.get(contentId);
    if(!content) throw new Error("content not found");
    await Content.delete(contentId).then(({data}) => data);
    Vue.delete(store.content, content._id);
    return content;
  },

  getResponse: async (contentId, questionId, groupId) => {
    console.log("getResponse", contentId, questionId, groupId);
    let content = await Content.getResponse(contentId, questionId, groupId, {ignoreCache: true}).then(({data}) => data);
    return content;
  },

  saveResponse: async (contentId, questionId, groupId, payload = {}) => {
    console.log("saveResponse", contentId, questionId, groupId, payload);
    let content = await Content.saveResponse(contentId, questionId, groupId, payload).then(({data}) => data);
    return content;
  },

  getQuestionResponses: async (contentId, questionId, groupId) => {
    if(!contentId || !questionId || !groupId) throw new Error("missing params");
    console.log("getQuestionResponses", contentId, questionId, groupId);
    let content = await Content.getGroupResponses(contentId, questionId, groupId, {ignoreCache: true, params: {shared: true}}).then(({data}) => data);
    return content;
  },

  getGroupResponses: async (contentId, questionId, groupId) => {
    if(!contentId || !questionId || !groupId) throw new Error("missing params");
    console.log("getGroupResponses", contentId, questionId, groupId);
    let content = await Content.getGroupResponses(contentId, questionId, groupId, {ignoreCache: true}).then(({data}) => data);
    return content;
  },

  share: async (id, { group, groups, users = [], license, relevant } = {}) => {
    if((!group && !groups) || !relevant) throw new Error("missing params");
    let content = await Content.createShares(id, { group, groups, users, license, relevant }).then(({data}) => data);
    return content;
  },
  unshare: async (id, { group, users = [], license } = {}) => {
    if(!group) throw new Error("missing params");
    let content = await Content.deleteShares(id, { group, users, license }).then(({data}) => data);
    return content;
  },
  getShares: async (id) => {
    let content = await Content.getShares(id, {ignoreCache: true}).then(({data}) => data);
    if(content?._id) Vue.set(store.content, content._id, content);
    return content;
  },

  publishToShares: async (id) => {
    return await Content.publishToShares(id).then(({data}) => data);
  },

  isHidden: async (id) => {
    if(!id) throw new Error("missing content id");
    let result = await Content.visability(id).then(({data}) => data);
    return result?.hidden || false;
  },
  restore: async (id) => {
    if(!id) throw new Error("missing content id");
    let result = await Content.restore(id).then(({data}) => data);
    return result;
  },
  hide: async (id) => {
    if(!id) throw new Error("missing content id");
    let result = await Content.hide(id).then(({data}) => data);
    return result;
  },

  report: async (id, { contentShare, category = 7, comments = "" } = {}) => {
    if(!id) throw new Error("missing content id");
    let result = await Content.report(id, { contentShare, category, comments }).then(({data}) => data);
    return result;
  },

  exportPDF: async (contentId, contentShareId, options) => {
    if(!contentId && !contentShareId) throw new Error("missing content id");
    let result = await Content.exportPDF(contentId, contentShareId, {options}).then(({data}) => data);
    return result;
  },

  checkExportPDF: async (contentId, contentShareId) => {
    if(!contentId && !contentShareId) throw new Error("missing content id");
    let result = await Content.checkExportPDF(contentId, contentShareId, {ignoreCache: true}).then(({data}) => data);
    return result;
  },

  pinShare: async (id, global = false) => {
    if(!id) throw new Error("missing content share id");
    let result = await Content.pinShare(id, {global}).then(({data}) => data);
    return result;
  },
  unpinShare: async (id, global = false) => {
    if(!id) throw new Error("missing content share id");
    let result = await Content.unpinShare(id, {global}).then(({data}) => data);
    return result;
  },

  favouriteShare: async (id) => {
    if(!id) throw new Error("missing content share id");
    let result = await Content.favouriteShare(id).then(({data}) => data);
    return result;
  },
  unfavouriteShare: async (id) => {
    if(!id) throw new Error("missing content share id");
    let result = await Content.unfavouriteShare(id).then(({data}) => data);
    return result;
  },

  statShareOpen: async (ids = []) => {
    if(!ids.length) throw new Error("missing content share id");
    let result = await Content.statShareOpen(ids).then(({data}) => data);
    return result;
  },

  statShareView: async (ids = []) => {
    if(!ids.length) throw new Error("missing content share id");
    let result = await Content.statShareView(ids).then(({data}) => data);
    return result;
  },
}

export default ContentCollection